const { getClientParams } = require("clients/api")

const findClientCodeUseCase = () => {
    return getClientParams().then(params => params.codClient)
}

export default findClientCodeUseCase